import { defineMessages } from "react-intl";
var menuMessages = defineMessages({
  //
  "首页": {
    id: "Menu.首页"
  },
  "告警信息": {
    id: "Menu.告警信息"
  },
  "未处理": {
    id: "Menu.未处理"
  },
  "已处理": {
    id: "Menu.已处理"
  },
  "我的链路": {
    id: "Menu.我的链路"
  },
  "常规链路": {
    id: "Menu.常规链路"
  },
  "FullMesh链路": {
    id: "Menu.FullMesh链路"
  },
  "地图模式": {
    id: "Menu.地图模式"
  },
  "我的设备": {
    id: "Menu.我的设备"
  },
  "我的客户端": {
    id: "Menu.我的客户端"
  },
  "操作日志": {
    id: "Menu.操作日志"
  },
  "用户访问日志": {
    id: "Menu.用户访问日志"
  },
  "构建网络": {
    id: "Menu.构建网络"
  },
  "中心节点": {
    id: "Menu.中心节点"
  },
  "边缘节点": {
    id: "Menu.边缘节点"
  },
  "设备配置": {
    id: "Menu.设备配置"
  },
  "设备绑定": {
    id: "Menu.设备绑定"
  },
  "HA配置": {
    id: "Menu.HA配置"
  },
  "中心线路配置": {
    id: "Menu.中心线路配置"
  },
  "客户端网段": {
    id: "Menu.客户端网段"
  },
  "白名单": {
    id: "Menu.白名单"
  },
  "模版配置": {
    id: "Menu.模版配置"
  },
  "LAN模版": {
    id: "Menu.LAN模版"
  },
  "SSID模版": {
    id: "Menu.SSID模版"
  },
  "CPE模版": {
    id: "Menu.CPE模版"
  },
  "高级配置": {
    id: "Menu.高级配置"
  },
  "隧道QoS": {
    id: "Menu.隧道QoS"
  },
  "QoS2.0": {
    id: "Menu.QoS2.0"
  },
  "互联网QoS": {
    id: "Menu.互联网QoS"
  },
  "ACL配置": {
    id: "Menu.ACL配置"
  },
  "ACL2.0": {
    id: "Menu.ACL2.0"
  },
  "单IP限速": {
    id: "Menu.单IP限速"
  },
  "应用限速": {
    id: "Menu.应用限速"
  },
  "Mac访问控制": {
    id: "Menu.Mac访问控制"
  },
  "互联网访问策略": {
    id: "Menu.互联网访问策略"
  },
  "对象分组": {
    id: "Menu.对象分组"
  },
  "IP分组": {
    id: "Menu.IP分组"
  },
  "端口分组": {
    id: "Menu.端口分组"
  },
  "节点分组": {
    id: "Menu.节点分组"
  },
  "域名分组": {
    id: "Menu.域名分组"
  },
  "应用管理": {
    id: "Menu.应用管理"
  },
  "自定义应用": {
    id: "Menu.自定义应用"
  },
  "自定义分组": {
    id: "Menu.自定义分组"
  },
  "系统应用": {
    id: "Menu.系统应用"
  },
  "流量分析(隧道内)": {
    id: "Menu.流量分析(隧道内)"
  },
  "五元组流量分析": {
    id: "Menu.五元组流量分析"
  },
  "流量分析": {
    id: "Menu.流量分析"
  },
  "日流量分析": {
    id: "Menu.日流量分析"
  },
  "4G流量分析": {
    id: "Menu.4G流量分析"
  },
  "4G流量统计": {
    id: "Menu.4G流量统计"
  },
  "分支流量": {
    id: "Menu.分支流量"
  },
  "流量统计": {
    id: "Menu.流量统计"
  },
  "Logo设置": {
    id: "Menu.Logo设置"
  },
  "账号管理": {
    id: "Menu.账号管理"
  },
  "运维账号": {
    id: "Menu.运维账号"
  },
  "客户端账号": {
    id: "Menu.客户端账号"
  },
  "账期清单": {
    id: "Menu.账期清单"
  },
  "企业信息": {
    id: "Menu.企业信息"
  },
  "设备列表": {
    id: "Menu.设备列表"
  },
  "ACL日志": {
    id: "Menu.ACL日志"
  },
  "链路管理": {
    id: "Menu.链路管理"
  },
  "APP用户管控": {
    id: "Menu.APP用户管控"
  },
  "DPI流量分析": {
    id: "Menu.DPI流量分析"
  },
  "压缩流量分析": {
    id: "Menu.压缩流量分析"
  },
  "去重流量分析": {
    id: "Menu.去重流量分析"
  },
  "链路负载率": {
    id: "Menu.链路负载率"
  },
  "配置信息汇总": {
    id: "Menu.配置信息汇总"
  },
  "企业账号管理": {
    id: "Menu.企业账号管理"
  },
  "合同管理": {
    id: "Menu.合同管理"
  },
  "计费设置": {
    id: "Menu.计费设置"
  },
  "计费分析": {
    id: "Menu.计费分析"
  },
  "账期管理": {
    id: "Menu.账期管理"
  },
  "任务": {
    id: "Menu.任务"
  },
  "POP点管理": {
    id: "Menu.POP点管理"
  },
  "vCPE管理": {
    id: "Menu.vCPE管理"
  },
  "黑名单配置": {
    id: "Menu.黑名单配置"
  },
  "国家IP库配置": {
    id: "Menu.国家IP库配置"
  },
  "压缩率分析": {
    id: "Menu.压缩率分析"
  },
  "去重率分析": {
    id: "Menu.去重率分析"
  },
  "POP点负载率": {
    id: "Menu.POP点负载率"
  },
  "库存管理": {
    id: "Menu.库存管理"
  },
  "出入库管理": {
    id: "Menu.出入库管理"
  },
  "库存信息": {
    id: "Menu.库存信息"
  },
  "出库统计": {
    id: "Menu.出库统计"
  },
  "版本管理": {
    id: "Menu.版本管理"
  },
  "版本汇总": {
    id: "Menu.版本汇总"
  },
  "版本更新": {
    id: "Menu.版本更新"
  },
  "版本说明": {
    id: "Menu.版本说明"
  },
  "客户端版本": {
    id: "Menu.客户端版本"
  },
  "客户端升级": {
    id: "Menu.客户端升级"
  },
  "机房信息": {
    id: "Menu.机房信息"
  },
  "运营商信息": {
    id: "Menu.运营商信息"
  },
  "关系人信息": {
    id: "Menu.关系人信息"
  },
  "密码管理": {
    id: "Menu.密码管理"
  },
  "参数设置": {
    id: "Menu.参数设置"
  },
  "CPE型号": {
    id: "Menu.CPE型号"
  },
  "区域设置": {
    id: "Menu.区域设置"
  },
  "大区设置": {
    id: "Menu.大区设置"
  },
  "授权管理": {
    id: "Menu.授权管理"
  },
  "客户管理": {
    id: "Menu.客户管理"
  },
  "其他": {
    id: "Menu.其他"
  },
  "告警配置": {
    id: "Menu.告警配置"
  },
  "健康标注配置": {
    id: "Menu.健康标注配置"
  },
  "4G卡登记": {
    id: "Menu.4G卡登记"
  },
  "客户端信息": {
    id: "Menu.客户端信息"
  },
  "链路信息": {
    id: "Menu.链路信息"
  },
  "上云申请": {
    id: "Menu.上云申请"
  },
  "客户账号管理": {
    id: "Menu.客户账号管理"
  },
  "客户Logo设置": {
    id: "Menu.客户Logo设置"
  },
  "客户功能设置": {
    id: "Menu.客户功能设置"
  },
  "QoS配置": {
    id: "Menu.QoS配置"
  },
  "安全防护": {
    id: "Menu.安全防护"
  },
  "客户端配置": {
    id: "Menu.客户端配置"
  },
  "基础防护": {
    id: "Menu.基础防护"
  },
  "引流配置": {
    id: "Menu.引流配置"
  },
  "多线路负载": {
    id: "Menu.多线路负载"
  },
  "多线路DNS代理": {
    id: "Menu.多线路DNS代理"
  },
  "域名解析": {
    id: "Menu.域名解析"
  },
  "Wi-Fi配置": {
    id: "Menu.Wi-Fi配置"
  },
  "告警接收": {
    id: "Menu.告警接收"
  },
  "告警事件": {
    id: "Menu.告警事件"
  },
  "健康标准": {
    id: "Menu.健康标准"
  },
  "客户端授权": {
    id: "Menu.客户端授权"
  },
  "客户账号": {
    id: "Menu.客户账号"
  },
  "客户合同": {
    id: "Menu.客户合同"
  },
  "客户联系人": {
    id: "Menu.客户联系人"
  },
  "出入库登记": {
    id: "Menu.出入库登记"
  },
  "历史数据": {
    id: "Menu.历史数据"
  },
  "任务信息": {
    id: "Menu.任务信息"
  },
  "任务信息(新)": {
    id: "Menu.任务信息(新)"
  },
  "POP点配置": {
    id: "Menu.POP点配置"
  },
  "Docker配置": {
    id: "Menu.Docker配置"
  },
  "资源库配置": {
    id: "Menu.资源库配置"
  },
  "告警等级": {
    id: "Menu.告警等级"
  },
  "登录背景图设置": {
    id: "Menu.登录背景图设置"
  },
  "Mac认证": {
    id: "Menu.Mac认证"
  },
  "用户分组": {
    id: "Menu.用户分组"
  },
  "资源分组": {
    id: "Menu.资源分组"
  },
  "SaaS访问权限": {
    id: "Menu.SaaS访问权限"
  },
  "客户端链路": {
    id: "Menu.客户端链路"
  },
  "对账单": {
    id: "Menu.对账单"
  },
  "专家路策略": {
    id: "Menu.专家路策略"
  },
  "控制器管理": {
    id: "Menu.控制器管理"
  },
  "编码设置": {
    id: "Menu.编码设置"
  },
  "URL资源": {
    id: "Menu.URL资源"
  },
  "源地址引流": {
    id: "Menu.源地址引流"
  },
  "目标引流": {
    id: "Menu.目标引流"
  },
  "屏蔽策略": {
    id: "Menu.屏蔽策略"
  },
  "访问权限": {
    id: "Menu.访问权限"
  },
  "移动客户端": {
    id: "Menu.移动客户端"
  },
  "CPE设备": {
    id: "Menu.CPE设备"
  },
  "黑名单": {
    id: "Menu.黑名单"
  },
  "关键词": {
    id: "Menu.关键词"
  },
  "企业迁移": {
    id: "Menu.企业迁移"
  },
  "静态解析分组": {
    id: "Menu.静态解析分组"
  },
  "域名关键词配置": {
    id: "Menu.域名关键词配置"
  },
  "IP限速": {
    id: "Menu.IP限速"
  },
  "IP限速2.0": {
    id: "Menu.IP限速2.0"
  },
  "POP点拓扑图": {
    id: "Menu.POP点拓扑图"
  },
  "专线资源": {
    id: "Menu.专线资源"
  },
  "任务中心": {
    id: "Menu.任务中心"
  },
  "预制路径标签": {
    id: "Menu.预制路径标签"
  },
  "出口方向": {
    id: "Menu.出口方向"
  },
  "链路带宽": {
    id: "Menu.链路带宽"
  },
  "告警模版": {
    id: "Menu.告警模版"
  },
  "代理优化": {
    id: "Menu.代理优化"
  }
});
export default menuMessages;